import React, { useState, useEffect } from 'react';
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
// Styles
import styles from './styles';

const BookingMessageDialog = ({ open, labels, users, onConfirm, onClose, classes }) => {
  const { title, message, closeLabel, confirmLabel } = labels;
  const [bookingMessage, setBookingMessage] = useState({ users, message: '' });
  const [wasClose, setWasClose] = useState(true);

  useEffect(() => {
    if (wasClose) {
      setWasClose(false);
      setBookingMessage({...bookingMessage, message: '' });
    }
  }, [wasClose, bookingMessage])

  const handleConfirm = () => {
    setWasClose(true);
    onConfirm(bookingMessage);
  };

  const handleClose = () => {
    setWasClose(true);
    onClose();
  };

  return (
    <div>
      <Dialog
        className={classes.container}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            { message }
          </DialogContentText>
          <TextField
            id="message"
            className={classes.textField}
            multiline
            rowsMax="4"
            margin="normal"
            inputProps={{
              'aria-label': 'bare'
            }}
            value={bookingMessage.message}
            onChange={e => setBookingMessage({ ...bookingMessage, message: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirm} color="secondary">
            { confirmLabel }
          </Button>
          <Button onClick={handleClose} color="secondary" autoFocus>
            { closeLabel }
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(BookingMessageDialog);
